import { Sheet, Stack, Typography } from '@mui/joy';
import { Label } from '@/ui/Label';

export function DayMealsHeader({ date, dailyNutrition, stickyTop, mealCount, isToday }) {
  const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });  
  const mealsStr = mealCount === 0 ? 'Nothing planned' : mealCount > 1 ? `${mealCount} meals` : `${mealCount} meal`;

  return (
    <Sheet
      variant="plain"
      sx={{
        position: 'sticky',
        top: stickyTop,
        zIndex: 50,
        mx: -2,
        px: 2,        
        py: 1.5,
        pt: 1.75,        
        backgroundColor: 'var(--joy-palette-neutral-100)',
      }}
    >
      <Stack gap={0.5}>
        <Stack
          direction="row"
          alignItems="baseline"
          gap={1}
        >
          <Typography level="h2">{dayName}</Typography>
          <Typography level="title-xs">
            {mealsStr}
            {dailyNutrition && ` · ${dailyNutrition.kcal} kcal`}
          </Typography>
          {isToday && <Typography level="title-xs"><Label color="primary">Today</Label></Typography>}
        </Stack>               
      </Stack>
    </Sheet>
  );
}

